import classNames from 'classnames';
import Overlay from '../../components/Overlay/Overlay';
import Portal from '../../components/Portal/Portal';
import Transition from '../../components/Transition/Transition';
import Theme from '../../types/enum/Theme';
import './Loader.scss';
import ILoaderProps from './LoaderProps';

const Loader = ({ isOpen, overlay = false, label = 'loading...', theme = Theme.DARK, className }: ILoaderProps) => {
  const classes = classNames(
    {
      loader: true,
      [`loader-${theme}`]: true,
    },
    className
  );

  return (
    <Portal>
      <Transition transitionName="loader-anim" speedIn={1000} isOpen={isOpen}>
        <div className="loader-shell">
          {overlay && <Overlay />}
          <div className={classes}>
            <div className="ring">
              <div />
              <div />
              <div />
              <div />
            </div>
            <div className="loader-label">{label}</div>
          </div>
        </div>
      </Transition>
    </Portal>
  );
};



export default Loader;
